import FileTypesField from './FileTypesField';
import PortalFormModal from './PortalFormModal';

import Attention from '../../ReusableComponents/Attention';

import React from 'react';
import moment from 'moment';

import { usePortalMutation } from '../hooks';

export default function WindowForm({ selection, item, onDone }) {
  const save = usePortalMutation(
    `selecoes/${selection.id}/prazos${item ? '/' + item.id : ''}`,
    item ? 'PUT' : 'POST'
  );
  return (
    <PortalFormModal
      title={item ? 'Editar prazo para recursos' : 'Novo prazo para recursos'}
      onClose={onDone}
      onSubmit={(e) => {
        e.preventDefault();
        const f = new FormData(e.currentTarget),
          data = Object.fromEntries(f);
        data.type = item?.type || data.type;
        data.max_files = Number(data.max_files);
        data.max_kb = Number(data.max_kb);
        data.allowed_types = f.getAll('allowed_types');
        data.requires_justification = f.has('requires_justification');
        data.requires_question = f.has('requires_question');
        data.allow_booklet = f.has('allow_booklet');
        data.position_id = data.position_id || null;
        data.response_published_at = data.response_published_at
          ? new Date(data.response_published_at).toISOString()
          : null;
        data.starts_at = new Date(data.starts_at).toISOString();
        data.ends_at = new Date(data.ends_at).toISOString();
        save.mutate(data, {
          onSuccess: () => onDone(),
        });
      }}
      busy={save.isLoading}
      allowed={save.allowed}
      error={save.error}
    >
      <div className="portal-admin-grid">
        <label className="form-label">
          <span className="portal-field-label">
            Título
            <Attention />
          </span>
          <input
            name="title"
            defaultValue={item?.title}
            className="form-control"
            required
            disabled={!save.allowed}
          />
        </label>
        <label className="form-label">
          <span className="portal-field-label">
            Tipo
            <Attention />
          </span>
          <select
            name="type"
            defaultValue={item?.type || 'application'}
            disabled={!!item || !save.allowed}
            className="form-control form-select"
            required
          >
            <option value="application">Inscrição</option>
            <option value="document">Documentos</option>
            <option value="question">Questão da prova</option>
            <option value="answer_key">Gabarito</option>
            <option value="result">Resultado</option>
            <option value="essay">Nota da redação</option>
            <option value="other">Outro</option>
          </select>
        </label>
        <label className="form-label">
          <span className="portal-field-label">
            Início
            <Attention />
          </span>
          <input
            name="starts_at"
            defaultValue={item ? moment(item.starts_at).format('YYYY-MM-DDTHH:mm') : ''}
            type="datetime-local"
            className="form-control"
            required
            disabled={!save.allowed}
          />
        </label>
        <label className="form-label">
          <span className="portal-field-label">
            Fim
            <Attention />
          </span>
          <input
            name="ends_at"
            defaultValue={item ? moment(item.ends_at).format('YYYY-MM-DDTHH:mm') : ''}
            type="datetime-local"
            className="form-control"
            required
            disabled={!save.allowed}
          />
        </label>
      </div>

      <label className="form-label">
        <span className="portal-field-label">
          Cargo
          <small className="text-muted">(opcional)</small>
        </span>
        <select
          className="form-control form-select"
          name="position_id"
          defaultValue={item?.position_id || ''}
        >
          <option value="">Todos</option>
          {selection.positions.map((p) => (
            <option key={p.id} value={p.id}>
              {p.title}
            </option>
          ))}
        </select>
      </label>

      <label className="form-label">
        <span className="portal-field-label">
          Instruções
          <small className="text-muted">(opcional)</small>
        </span>
        <textarea
          className="form-control"
          name="instructions"
          rows={3}
          defaultValue={item?.instructions}
        />
      </label>

      <div className="portal-admin-grid">
        <label className="form-label">
          <span className="portal-field-label">
            Máximo de anexos
            <Attention />
          </span>
          <input
            className="form-control"
            name="max_files"
            type="number"
            min={0}
            max={3}
            defaultValue={item?.max_files ?? 3}
            required
          />
        </label>
        <label className="form-label">
          <span className="portal-field-label">
            Limite por arquivo (KB)
            <Attention />
          </span>
          <input
            className="form-control"
            name="max_kb"
            type="number"
            min={100}
            max={5120}
            defaultValue={item?.max_kb ?? 5120}
            required
          />
        </label>
        <FileTypesField value={item?.allowed_types} />
        <label className="form-label">
          <span className="portal-field-label">
            Publicar respostas a partir de
            <small className="text-muted">(opcional)</small>
          </span>
          <input
            className="form-control"
            type="datetime-local"
            name="response_published_at"
            defaultValue={
              item?.response_published_at
                ? moment(item.response_published_at).format('YYYY-MM-DDTHH:mm')
                : ''
            }
          />
        </label>
      </div>

      <label className="portal-check">
        <input
          name="requires_justification"
          type="checkbox"
          defaultChecked={item?.requires_justification ?? true}
        />{' '}
        Exigir justificativa
      </label>

      <label className="portal-check">
        <input name="requires_question" type="checkbox" defaultChecked={item?.requires_question} />{' '}
        Exigir seleção de questão
      </label>

      <label className="portal-check">
        <input name="allow_booklet" type="checkbox" defaultChecked={item?.allow_booklet} />{' '}
        Disponibilizar caderno durante o recurso, sem liberar gabarito
      </label>
    </PortalFormModal>
  );
}
